import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'
import Notifications from 'vue-notification'
import VuejsDialog from 'vuejs-dialog'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
const moment = require('moment')

Vue.use(require('vue-moment'), {
  moment,
})

Vue.config.productionTip = false

Vue.use(Notifications)
Vue.use(VuejsDialog)
Vue.use(Datetime)

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DB_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig)

firebase.auth().onAuthStateChanged(async user => {
  await store.dispatch('fetchUserInformation', user)
  if (user === null) {
    store.dispatch('logoutUser', null)
  } else if (user && user.emailVerified === false) {
    console.log('sending verification email')
    user.sendEmailVerification()
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
